import { Flex, Typography, theme } from 'antd';
import { isSocialPlatform, type Platform } from '@/types/api/platforms';

export const TooltipContentEcho = ({
  label,
  value,
  selectedPlatform,
}: {
  label: string;
  value: number;
  selectedPlatform: Platform;
}) => {
  const { token } = theme.useToken();

  return (
    <Flex vertical gap={token.marginXS}>
      <Typography.Text style={{ fontSize: token.fontSizeSM, fontWeight: 500 }}>
        {label}
      </Typography.Text>
      <Typography.Text style={{ color: token.colorPrimary, fontWeight: 500 }}>
        {value}%
      </Typography.Text>
      <Flex vertical>
        <Typography.Text style={{ color: token.colorTextSecondary, fontSize: token.fontSizeSM }}>
          {isSocialPlatform(selectedPlatform)
            ? `of people viewing your content on ${selectedPlatform} are`
            : 'of people listening to your audio podcast on Podcast Players are'}
        </Typography.Text>
        <Typography.Text
          style={{ color: token.colorTextSecondary, fontSize: token.fontSizeSM, fontWeight: 500 }}
        >
          {label}
        </Typography.Text>
      </Flex>
    </Flex>
  );
};
